import React, {useState} from "react"

import {createEquipmentCategory, updateEquipmentCategoryById} from "../api"

import CustomPopup from "../../../toolkits/CustomPopup/CustomPopup"
import TextInput from "../../../toolkits/TextInput/TextInput"
import SmallButton from "../../../toolkits/SmallButton/SmallButton"

import {SUCCESS_CODE, ERROR_CODE} from "../../../constants/other"


const CreateUpdateCategoryPopup = ({category, setUserMessage, refreshTable, close}) => {
    const [name, setName] = useState(category?.name)

    const handleSubmit = () => {
        if (category) {
            updateEquipmentCategoryById(category.id, {name: name})
                .then(() => {
                    refreshTable()
                    setUserMessage({message: "Equipment Category was successfully updated!", code: SUCCESS_CODE})
                })
                .catch(error => {
                    setUserMessage({message: error.response.data.message, code: ERROR_CODE})
                })
        } else {
            createEquipmentCategory({name: name})
                .then(() => {
                    refreshTable()
                    close()
                    setUserMessage({message: "Equipment Category was successfully created!", code: SUCCESS_CODE})
                })
                .catch(error => {
                    console.log(error)
                    setUserMessage({message: error.response.data.message, code: ERROR_CODE})
                })
        }
    }

    return (
        <CustomPopup text_title={`${category ? "Edit" : "Create"} Category`}>
            <TextInput
                text_label="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
            />
            <div className="popup-bottom">
                <div className="popup-bottom-button-container">
                    <SmallButton btnType="secondary" onClick={close}> CANCEL </SmallButton>
                    <SmallButton
                        type="submit"
                        onClick={handleSubmit}
                        disabled={!name}
                    >{category ? "SAVE" : "CREATE"}</SmallButton>
                </div>
            </div>
        </CustomPopup>
    )
}

export default CreateUpdateCategoryPopup
